import { InvoiceLegend } from './../../../@shared/constants/invoiceLegend';
import { InjectionToken } from '@angular/core';
import { AdditionalDrop, PageQueryParam } from 'src/@core/models';

export const API_URL = new InjectionToken<string>('apiUrl');

export const API = {
  AUDIT: {
    GET: `/api/audit`
  },
  // Vehicle type
  VEHICLE_TYPE: {
    CREATE: '/api/vehicle-type',
    GET_VEHICLE_TYPES: '/api/vehicle-type',
    UPDATE_VEHICLE_TYPES: '/api/vehicle-type',
    UPDATE: (id: string) => {
      return `/api/vehicle-type/${id}`;
    },
    DELETE: (id: string) => {
      return `/api/vehicle-type/${id}`;
    }
  },
  BRANCH: {
    GET_BRANCHS: '/api/branch',
    CREATE: '/api/branch',
    UPDATE_BRANCHS: '/api/branch',
    GET_ORGANISATION: () => {
      return `/api/branch/GetOrganisation`;
    }
  },
  POSTCODE: {
    CREATE: '/api/postcode-zone',
    GET_POSTCODE: '/api/postcode-zone',
    UPDATE_POSTCODE: '/api/postcode-zone',
    UPDATE: (id: string) => {
      return `/api/postcode-zone/${id}`;
    },
    DELETE: (id: string) => {
      return `/api/postcode-zone/${id}`;
    }
  },
  QUOTATION: {
    CREATE: '/api/quotation',
    GET_QUOTATION: '/api/quotation',
    GET_SINGLEQUOTATION: (id: string) => { return `/api/quotation/GetSingle/${id}` },
    GET_QUOTATIONCONVERT: (id: string) => { return `/api/quotation/Convert/${id}` },
    DELETE: (id: string) => {
      return `/api/quotation/${id}`;
    },
    GET_SAMEDAY_PRICING: '/api/quotation/CalculateSameDayPricing',
    GET_QUOTATION_FOR_CURRENT_USER: '/api/quotation/current',
    GET_QUOTATION_NEED_PROCESSING: '/api/quotation/needProcessing'
  },
  HX: {
    GET_NOTIFICATIONS: '/api/hx/getNotifications',
    ACK_NOTIFICATION: '/api/hx/acknowledgeNotification',
  },
  SIGNALR: {
    SIGNALHUB: '/signalhub',
    HX_QUOTE_RECIEVED: 'HXQuotesReceived',
    HX_QUOTE_CANCELLED: 'HXQuotesCancelled',
    HX_STATUS_UPDATE: 'HxStatusUpdate',
    HX_NOTIFICATION_ACK: 'HXNotificationAcknowledged',
    HX_NO_QUOTES: 'HXNoQuotes',
    HX_NO_STATUS: 'HXNoStatus',
    GENERAL_ALERT: 'GeneralAlert',
    BIRMINGHAM_QUOTE_BOOKED: 'QuoteBookedBirmingham',
    BRISTOL_QUOTE_BOOKED: 'QuoteBookedBristol',
    GLOBAL_QUOTE_BOOKED: 'QuoteBookedGlobal'
  },
  FAILURE_REASON: {
    CREATE: '/api/delivery-failure',
    GET_FAILURE_REASON: '/api/delivery-failure',
    UPDATE_FAILURE_REASON: '/api/delivery-failure',
    DELETE: (id: string) => {
      return `/api/delivery-failure/${id}`;
    }
  },
  SURCHARGE: {
    GET_SURCHARGES: '/api/surcharge',
    CREATE: '/api/surcharge',
    UPDATE_SURCHARGES: '/api/surcharge',
    DELETE: (id: string) => {
      return `/api/surcharge/${id}`;
    }
  },
  SURCHARGE_TYPE: {
    GET_SURCHARGE_TYPES: '/api/surcharge-type'
  },
  EXCEPTION_CODE: {
    CREATE: '/api/exception-code',
    GET_EXCEPTION_CODE: '/api/exception-code',
    GET_EXCEPTIONCODE_FOR_POD:
      '/api/exception-code/GetExceptionCodeForPOD',
    UPDATE_EXCEPTION_CODE: '/api/exception-code',
    DELETE: (id: string) => {
      return `/api/exception-code/${id}`;
    }
  },
  USER: {
    GET_USERS: '/api/user',
    CREATE: '/api/user',
    UPDATE: (id: string) => {
      return `/api/user/${id}`;
    },
    DELETE: (id: string) => {
      return `/api/user/${id}`;
    },
    GET: (id: string) => {
      return `/api/user/${id}`;
    },
    CHANGE_PASSWORD: (id: string) => {
      return `/api/user/ChangePassword/${id}`;
    },
    GET_SALES_PERSON_LIST: '/api/user/getSalesPersonList'
  },
  ROLE: {
    GET_ROLES: '/api/role'
  },
  MENU: {
    GET_MENUS: '/api/menu',
    CURRENT_LOGIN: '/api/menu/currentlogin'
  },
  SUBCONTRACTOR: {
    GET_SUBCONTRACTORS: '/api/subcontractor',
    GET_ALL_SUBCONTRACTORS_FOR_DROPDOWN: (searchText: string) => `/api/subcontractor/allfordropdown?searchText=${searchText}`,
    GET_SUBCONTRACTORS_FOR_DROPDOWN: (searchText: string) => `/api/subcontractor/dropdown?searchText=${searchText}`,
    GET_HXSUBCONTRACTORS_FOR_DROPDOWN: (searchText: string) => `/api/subcontractor/hxdropdown?searchText=${searchText}`,
    CREATE: '/api/subcontractor',
    UPDATE: (id: string) => {
      return `/api/subcontractor/${id}`;
    },
    DELETE: (id: string) => {
      return `/api/subcontractor/${id}`;
    },
    VERIFY_EMAIL: (id: string) => {
      return `/api/subcontractor/VerifyEmail?subcontractorId=${id}`;
    },
    UPDATE_EMAIL: '/api/subcontractor/UpdateEmail',
    SEND_EMAIL: '/api/subcontractor/SendEmail',
    CREATEXEROCONTACT: '/api/subcontractor/CreateXeroContact'
  },
  SUBCONTRACTOR_NOTE: {
    GET_SUBCONTRACTOR_NOTE: '/api/subcontractorNote',
    CREATE: '/api/subcontractorNote'
  },
  ADDRESS_BOOK: {
    GET_ADDRESS_BOOK: '/api/addressbook',
    GET_CUSTOMER_ADDRESS: (customerId: string) => `/api/addressbook/customer/${customerId}`,
    CREATE: '/api/addressbook',
    UPDATE: (id: string) => {
      return `/api/addressbook/${id}`;
    },
    DELETE: (id: string) => {
      return `/api/addressbook/${id}`;
    },
    GET: (id: string) => {
      return `/api/addressbook/${id}`;
    }
  },
  TARIFF: {
    GET_TARIFF: '/api/tariff',
    UPDATE_TARIFF: '/api/tariff',
    CREATE: '/api/tariff',
    UPDATE: (id: string) => {
      return `/api/tariff/${id}`;
    },
    DELETE: (id: string) => {
      return `/api/tariff/${id}`;
    },
    GET_TARIFF_TYPE: '/api/tariff/GetTariffType',
    UPDATE_TARIFF_BOX_RATES: '/api/tariff/UpdateTariffBoxRates',
    UPDATE_TARIFF_PACKET_RATES: '/api/tariff/UpdateTariffPacketRates',
    UPDATE_TARIFF_SAME_DAY_RATES: '/api/tariff/UpdateTariffSameDays',
    UPDATE_TARIFF_PALLET_RATES: '/api/tariff/UpdateTariffPallets'
  },
  SUPPLIER: {
    GET_SUPPLIERS: '/api/supplier',
    GET_SUPPLIERS_FOR_LOOKUP: (searchText: string) => `/api/supplier/lookup?searchText=${searchText}`,
    CREATE: '/api/supplier',
    UPDATE: (id: string) => {
      return `/api/supplier/${id}`;
    },
    DELETE: (id: string) => {
      return `/api/supplier/${id}`;
    },
    GET_USER_SUPPLIERS: (id: string) => {
      return `/api/user/${id}/suppliers`;
    },
    GET_CUSTOMER_SUPPLIERS: (customerId: string) => { return `/api/supplier/${customerId}` },
    GET_ALL_BOX_RATE: '/api/supplier/GetAllBoxRates',
    UPDATE_BOX_RATES: '/api/supplier/UpdateBoxRates',
    UPDATE_CONSIGNMENTS: '/api/supplier/UpdateConsignments',
    GET_ALL_AVAILABLE_SERVICE_CONSIGNMENT:
      '/api/supplier/GetAllAvailableServiceConsignment',
    UPDATE_SUPPLIER_SURCHARGES: '/api/supplier/UpdateSurcharge',
    GET_ALL_SUPPLIER_SURCHARGE: '/api/supplier/GetAllSurcharge',
    GET_ALL_PALLET: (id: string) =>
      `/api/supplier/GetAllPallet?supplierID=${id}`,
    GET_PALLET_SURCHARGE: (id: string) =>
      `/api/supplier/palletSurcharge?supplierID=${id}`,
    UPDATE_PALLET: '/api/supplier/UpdatePallets',
    CREATE_OR_UPDATE_PALLET_SURCHARGE: '/api/supplier/palletSurcharge'
  },
  CUSTOMER: {
    CREATE: '/api/customer',
    GET_CUSTOMER_NEW: '/api/customer/getNew',
    GET_CUSTOMER: '/api/customer',
    GET_CUSTOMER_FOR_DROPDOWN: '/api/customer/dropdown',
    GET_CUSTOMER_FOR_LOOKUP: (searchText: string) => `/api/customer/lookup?searchText=${searchText}`,
    GET_CUSTOMER_FOR_LOOKUP_MIN: (searchText: string) => `/api/customer/minlookup?searchText=${searchText}`,
    UPDATE: (id: string) => {
      return `/api/customer/${id}`;
    },
    DELETE: (id: string) => {
      return `/api/customer/${id}`;
    },
    GET_ONE: (id: string) => {
      return `/api/customer/${id}`;
    },
    GET_CUSTOMER_ENTITIES: (id: string) => {
      return `/api/customer/customerentities/${id}`
    },
    ADD_SUPPLIER_CUSTOMER: '/api/customer/AddCustomerSupplier',
    ADD_VEHICLETYPE_CUSTOMER: '/api/customer/AddCustomerVehicleType',
    GET_CUSTOMER_USAGE_SUMMARY: '/api/customer/count',
    GET_CUSTOMER_STATUS: (id: string) => {
      return `/api/customer/${id}/UseStatus`;
    },
    GETALLCONTACT: '/api/subcontractor/GetAllXeroContact',
    UPDATE_CUSTOMERXEROCONTACT: (id: string) =>
      `/api/customer/UpdateCustomerXeroContact/${id}`,
    UPDATE_CUSTOMER_SPEND: '/api/customer/UpdateSpend',
    CREATE_CUSTOMERXEROCONTACT: `/api/customer/CreateXeroContact`,
    UPDATE_CUSTOMER_XERO_CONTEACT_WITH_CONTACTID: (
      idcustomer: string,
      xeroid: string
    ) =>
      `/api/customer/UpdateCustomerXeroContactWithContactID/${idcustomer}/${xeroid}`,
    GET_CUSTOMER_XERO_INFO: (id: string) =>
      `/api/customer/GetCustomerXeroInfo/${id}`,
    GET_CONSIGNMENT_OVERVIEW: '/api/customer/consignmentOverview',
    GET_CONSIGNMENT_OVERVIEW_BY_SEARCHTEXT:
      '/api/customer/consignmentOverviewBySearchText',
    GET_CONSIGNMENT_OVERVIEW_BY_SEARCHTEXT_FROMCONID:
      '/api/customer/consignmentBySearchTextFromConId',
    GET_CONSIGNMENT_OVERVIEW_BY_SEARCHTEXT_FROMCUSTNUMS:
      '/api/customer/consignmentBySearchTextFromCustNums',
    GET_EXPORT_DATA: '/api/customer/csv',
    GET_CONSIGNMENT_BY_CUSTOMER_ID: (id: string) =>
      `/api/customer/${id}/consignment`,
    GET_CONSIGNMENT_BY_CUSTOMER_ID_SEARCHTEXT: (id: string) =>
      `/api/customer/${id}/consignmentBySearchText`,
    PRINT: (id: string) => `/api/customer/PrintCustomer/${id}`,
    CREATE_QUOTATION_CUSTOMER: '/api/customer/quotationCustomer',
    OPERATING_PROCEDURE: '/api/customer/operatingProcedure',
    OPERATING_PROCEDURE_DELETE: '/api/customer/operatingProcedure/delete',
    GET_CUSTOMER_SOP: (customerId: string) => `/api/customer/${customerId}/sop`,
    GET_CUSTOMER_VEHICLETYPES: (customerId: string) => `/api/customer/CustomerVehicleTypes/${customerId}`,
    UPLOAD_CUSTOMER_ATTACHMENT: (id: string) => {
      return `/api/customer/${id}/customerAttachment`;
    },
    GET_CUSTOMER_ATTACHMENT: (mediaObjectId: string) => {
      return `/api/customer/${mediaObjectId}/GetCustomerDocument`;
    },
    DELETE_CUSTOMER_ATTACHMENT: (mediaObjectId: string) => {
      return `/api/customer/${mediaObjectId}/DeleteCustomerDocument`;
    },
    GET_CUSTOMER_MEDIAOBJECTS: (customerId: string) => {
      return `/api/customer/${customerId}/GetCustomerMediaObjects`;
    },
  },
  CONSIGNMENT: {
    CREATE: '/api/consignment/startConsignment',
    UPDATE_CONSIGNMENT3: '/api/consignment/UpdateConsignment3',
    UPDATE: (id: string) => {
      return `/api/consignment/${id}`;
    },
    GET_ONE: (id: string) => {
      return `/api/consignment/${id}`;
    },
    GENERATE_PRICE: '/api/consignment/CalculatePricing',
    CALCULATE_CHEAPEST_SUPPLIER: (id: string) => `/api/consignment/${id}/CalculateCheapestSupplier`,
    DELETE: id => `/api/consignment/${id}`,
    COUNT_NEW_JOB: '/api/consignment/countNewJob',
    COUNT_OPEN_JOB: '/api/consignment/countOpenJob',
    COUNT_EXCEPTION_JOB: '/api/consignment/countExceptionJob',
    COUNT_DISCREPANCY_JOB: '/api/consignment/countDiscrepancyJob',
    GET_CONSIGNMENT: '/api/consignment',
    GET_CONSIGNMENTFORCUST: 'api/consignment/GetAllForCustomer',
    CHANGE_STATUS: (id: string, status: number) => {
      return `/api/consignment/{${id}}/status/${status}`;
    },
    PROCESS_CUSTOMER_ON_HOLD: {
      GENERATE_OVERRIDE_PASSWORD: (id: string) =>
        `/api/consignment/${id}/overridepassword`,
      VALIDATE_OVERRIDE_PASSWORD: (id: string, password: string) =>
        `/api/consignment/${id}/${password}/validate`
    },
    BOOK_HX_LOADFROMQUOTEOVERIDE: (consignmentId: string, loadId: number, quoteId: number, companyToUse: number, agreedRate: number) =>
      `/api/integration/hx/${consignmentId}/bookloadfromquoteoveride?loadid=${loadId}&quoteId=${quoteId}&companyToUse=${companyToUse}&agreedRate=${agreedRate}`,
    GET_SERVICE_LEVEL: {
      PALLET: '/api/consignment/palletservicelevels'
    },
    COPY: (id: string) => `/api/consignment/${id}/copy`,
    CLONE: (id: string) => `/api/consignment/${id}/clone`,
    CLONE_RTS: (id: string) => `/api/consignment/${id}/cloneRts`,
    GET_CHARGES: (id: string) => `/api/consignment/${id}/charge`,
    CREATE_CHARGE: (id: string) => `/api/consignment/${id}/charge`,
    DELETE_CHARGE: (id: string, chargeId: string) =>
      `/api/consignment/${id}/charge/${chargeId}`,
    UPDATE_CHARGE: (id: string) => `/api/consignment/${id}/charge`,
    EDIT: (id: string) => `/api/consignment/${id}/general`,
    POD: {
      GET_ALL: additionalDetailId =>
        `/api/consignmentAdditionalDetail/${additionalDetailId}/pod`,
      CREATE: additionalDetailId =>
        `/api/consignmentAdditionalDetail/${additionalDetailId}/pod`,
      UPDATE: (additionalDetailId, podId) =>
        `/api/consignmentAdditionalDetail/${additionalDetailId}/pod/${podId}`
    },
    PRINT: {
      PRINT_ALL: (id: string) => ``,
      PRINT_PACKAGES: (id: string) => ``,
      PRINT_PALLETS: (id: string) => ``,
      PRINT_SUPPLIER: () => `/api/consignment/getsupplierlabels`
    },
    CUSTOMER_PORTAL_DASHBOARD: () =>
      '/api/consignment/customer/dashboard',
    CALCULATE_CHARGE: (id: string) => {
      return `/api/consignment/${id}/CalculateCharge`;
    },
    GET_RECALCULATE_CHARGE: (id: string) => {
      return `/api/consignment/${id}/CalculateCharge`;
    }
  },
  CONSIGNMENT_NOTE: {
    CREATE: '/api/consignmentNote',
    UPDATE: (id: string) => {
      return `/api/consignmentNote/${id}`;
    },
    DELETE: (id: string) => {
      return `/api/consignmentNote/${id}`;
    },
    GET_CONSIGNMENT_NOTE: (id: string, internal: boolean) => {
      if (internal) {
        return `/api/consignmentNote/${id}?internal=${internal}`;
      } else {
        return `/api/consignmentNote/${id}`;
      };
    }
  },
  CONSIGNMENT_POD: {
    CREATE: '/api/consignmentPod',
    UPDATE: (id: string) => `/api/consignmentPod/${id}`,
    DELETE: (id: string) => `/api/consignmentPod/${id}`,
    GET_BY_CONSIGNMENT: (id: string) => {
      return `/api/consignmentPod?consignmentId=${id}`;
    },
    UPDATE_POD_ATTACHMENT: (id: string) => {
      return `/api/consignmentPod/${id}/podAttachment`;
    },
    UPDATE_INVOICE_ATTACHMENT: (id: string) => {
      return `/api/consignmentPod/${id}/invoiceAttachment`;
    },
    DELETE_INVOICE_ATTACHMENT: (id: string, mediaObjectId: string) => {
      return `/api/consignmentPod/${id}/invoiceAttachment/${mediaObjectId}`;
    },
    DELETE_POD_ATTACHMENT: (id: string, mediaObjectId: string) => {
      return `/api/consignmentPod/${id}/podAttachment/${mediaObjectId}`;
    },
    GET_RECIPIENT_EMAILS: (consignmentNumber: number) => {
      return `/api/consignmentPod/${consignmentNumber}/emails`;
    },
    SEND_POD_EMAIL: '/api/consignmentPod/sendEmailPod'
  },
  CONSIGNMENT_LOG: {
    GET_LOG: (
      consignmentId: string,
      pageQueryParam?: PageQueryParam
    ) => {
      const baseUrl = `/api/consignment/${consignmentId}/log`;
      const pageQuery = pageQueryParam
        ? `?page=${pageQueryParam.page}&pageSize=${pageQueryParam.pageSize}`
        : '';
      return `${baseUrl}${pageQuery}`;
    }
  },
  RATE_SERVICE: {
    CREATE: '/api/rateservice'
  },
  PACKET_SURCHARGE: {
    GET_PACKET_SURCHARGE: (ratesServiceID: string) => {
      return `/api/packetSurcharge/${ratesServiceID}`;
    },
    UPDATE: `/api/packetSurcharge`
  },
  PACKET_RATE: {
    GET_PACKET_RATE: `/api/packetrate`,
    UPDATE: `/api/packetrate`
  },
  BOX_RATE: {
    GET_BOX_RATE: `/api/boxrate`,
    UPDATE: `/api/boxrate`
  },
  PALLET_RATE: {
    GET_PALLET_RATE: `/api/palletrate`,
    UPDATE: `/api/palletrate`
  },
  PALLET_SURCHARGE: {
    GET_PALLET_SURCHARGE: (ratesServiceID: string) => {
      return `/api/palletSurcharge/${ratesServiceID}`;
    },
    UPDATE: `/api/palletSurcharge`
  },
  SAME_DAY_RATE: {
    GET_SAME_DAY_RATE: `/api/sameDayRate`,
    UPDATE: `/api/sameDayRate`
  },
  COUNTRY: {
    GET_COUNTRIES: '/api/norskGlobalCountry',
    DELETE: (id: string) => {
      return `/api/norskGlobalCountry/${id}`;
    },
    IMPORT: '/api/norskGlobalCountry',
    UPDATE_COUNTRIES: '/api/norskGlobalCountry'
  },
  ZONE: {
    GET_ZONES: '/api/norskGlobalZone',
    IMPORT: '/api/norskGlobalZone'
  },
  INTERNATIONAL_SUPPLIER: {
    GET_INTERNATIONAL_SUPPLIERS: '/api/norskGlobal',
    UPLOAD_LOGO: id => `/api/norskGlobal/UploadLogo/${id}`
  },
  GOOGLE_MAP: {
    CALLGEOAPI: (code: string, key: string) => {
      return `https://maps.googleapis.com/maps/api/geocode/json?address=${code}&key=${key}`;
    }
  },
  // PHAN ADDITION DROPS
  ADDITIONAL_DROPS: {
    GETALL: '/api/consignment/AdditionalDetails',
    GETALL_BY_CONSIGMENT: id =>
      `/api/consignment/AdditionalDetails/GetByCosignmentID/${id}`,
    GETONE: id => `/api/consignment/AdditionalDetails/${id}`,
    DELETE: id => `/api/consignment/AdditionalDetails/${id}`,
    EDIT: id => `/api/consignment/AdditionalDetails/${id}`,
    ADD: '/api/consignment/AdditionalDetails'
  },
  ORDER_ADDITIONAL_DROPS: {
    GETALL: '/api/consignment/OrderAdditionalDetails',
    GETALL_BY_ORDERTEMPLATE: id =>
      `/api/consignment/OrderAdditionalDetails/GetByOrderTemplateID/${id}`,
    GETONE: id => `/api/consignment/OrderAdditionalDetails/${id}`,
    DELETE: id => `/api/consignment/OrderAdditionalDetails/${id}`,
    EDIT: id => `/api/consignment/OrderAdditionalDetails/${id}`,
    ADD: '/api/consignment/OrderAdditionalDetails'
  },
  // Base rate
  BASE_RATE: {
    GET_BASE_RATE: '/api/baseRate/GetBaseRateByServiceName',
    UPDATE: '/api/baseRate',
    IMPORT_EXPRESS_SAVER: '/api/baseRate',
    UPDATE_EXPEDITED: '/api/BaseRateExpedited',
    IMPORT_EXPEDITED: '/api/BaseRateExpedited',
    UPDATE_STANDARD_SINGLE: '/api/BaseRateSingle',
    IMPORT_STANDARD_SINGLE: '/api/BaseRateSingle',
    UPDATE_STANDARD_MULTI: '/api/BaseRateMulti',
    IMPORT_STANDARD_MULTI: '/api/BaseRateMulti',
    IMPORT_EXPRESS: '/api/BaseRateExpress',
    UPDATE_EXPRESS: '/api/BaseRateExpress'
  },

  // Road rate
  ROAD_RATE: {
    GET_ROAD_RATE: '/api/roadRate/getAllRoadRate',
    UPDATE: '/api/roadRate',
    IMPORT_ROAD_RATE: '/api/roadRate'
  },

  // CUSTOMER INVOICE
  CUSTOMER_INVOICE: {
    POST: '/api/invoices/SearchInvoiceV2',
    PROCESS_INVOICE: '/api/invoices/ProcessInvoice',
    PREVIEW_INVOICE: '/api/invoices/PreviewInvoice',
    CHANGE_INVOICE_STATE: '/api/invoices/ChangeInvoiceState',
    CHANGE_INVOICE_LEGEND: (
      consignmentId: string,
      legend: InvoiceLegend
    ) => `/api/invoices/consignment/${consignmentId}/legend/${legend}`,
    REVERSE_INVOICE_LEGEND: (consignmentId: string) =>
      `/api/invoices/consignment/${consignmentId}/legend/reverse`
  },

  // Print
  PRINT: {
    PRINT_PDF: '/api/print'
  },
  SERVER_PRINT: {
    ASAP_LABEL: (id: string) =>
      `/api/serverprint/asaplabel/consignment/${id}`,
    DX_LABEL: (id: string) =>
      `/api/serverprint/dxlabel/consignment/${id}`,
    PF_TPN_LABEL: (id: string) =>
      `/api/serverprint/pftpnlabel/consignment/${id}`,
    SUPPLIER_LABEL: '/api/serverprint/supplierlabels',
    PRINT_ENDDAY_MANIFEST: '/api/serverprint/printEndDayManifest',
    PRINT_ALL_CONSIGNMENTS: '/api/serverprint/printAllConsignments',
    PRINT_ALL_DRIVER_CONSIGNMENT:
      '/api/serverprint/printAllDriverConsignment',
    LABEL_MULTIPLE: '/api/serverprint/labelMultiple',
    CONSIGNMENT_SUMMARY: (id: string) =>
      `/api/serverprint/summary/consignment/${id}`
  },
  // International surcharge
  INTERNATIONAL_SURCHARGE: {
    GET_SURCHARGE: '/api/NorskGlobalSurcharge/getAllSurcharge',
    UPDATE: '/api/NorskGlobalSurcharge'
  },

  // NEW SUPPLIER INVOICE
  NEW_SUPPLIER_INVOICE: {
    CREATE: '/api/SubcontractorInvoice',
    CHANGE_INVOICE_ATTACHMENT:
      '/api/SubcontractorInvoice/ChangeSubContractorInvoiceAttachment',
    GET_CONSIGMENT: '/api/SubcontractorInvoice/GetConsignment'
  },

  // SUPPLIER INVOICE SEARCH
  SUPPLIER_INVOICE_SEARCH: {
    GET: '/api/SubcontractorInvoice/GetAllSubcontractorInvoicesV2'
  },
  AUTHORISE_INVOICE: {
    POST: '/api/SubcontractorInvoice/GetAllSubcontractorInvoicesV2',
    POST_CHANGE_AUTHORISE:
      '/api/SubcontractorInvoice/AuthoriseSubcontractorInvoice',
    POST_TO_XERO: '/api/SubcontractorInvoice/PostToXero',
    PDF_VIEW: id =>
      `/api/SubcontractorInvoice/api/DownloadPdfFile/${id}`,
    PRINT_HARD_COPY:
      '/api/SubcontractorInvoice/PrintHardCopySubcontractorInvoice'
  },
  PRINT_CUSTOMER_STATEMENT: {
    PRINT: id => `/api/invoices/PrintCustomerStatement/${id}`
  },
  // Login
  LOGIN: {
    TOKEN: '/api/token',
    FIRST_LOGIN: '/api/user/firstlogin',
    FORGOT_PASSWORD: '/api/user/forget',
    GET_CURRENT_USER: '/api/user/current',
    VALIDATE_TOKEN: '/api/token/validate'
  },

  // Setting
  CUSTOMER_PORTAL: {
    SETTING: {
      GET_USER_INFORMATION: '/api/user/current',
      SAVE_USER_INFORMATION: '/api/user/customer/update',
      GET_USERS_CURRENT_BRANCH: '/api/user/branch/users',
      CREATE_USER: '/api/user/customer/create'
    },
    GET_CURRENT_USER: '/api/user/current',
    VALIDATE_TOKEN: '/api/token/validate',
    COLLECTION: {
      GET_CURRENT_CUSTOMER_DETAIL: '/api/customer/current',
      CREATE: '/api/consignment/CreateFromCustomer',
      GET_PRICE: '/api/consignment/PriceFromCustomer'
    }
  },
  POD_ADDITIONAL_DROP: {
    GET: id => `/api/consignment/GetPOD?additionalDropID=${id}`,
    PUT: id => `/api/consignment/PutConsignmentPOD?id=${id}`,
    CREATE: '/api/consignment/CreatePOD'
  },
  INTEGRATION: {
    GET_PARCEL_FORCE_LABEL: id =>
      `/api/integration/parcelforce/${id}/label`,
    GET_TPN_LABEL: id => `/api/integration/tpn/${id}/label`,
    GET_TPN_TRACKING: id => `/api/integration/tpn/${id}/tracking`,
    GET_DX_DEPOT: postCode =>
      `/api/integration/dx/${encodeURIComponent(postCode)}/depot`,
    GET_DX_HUBZONE: depot => `/api/integration/dx/${depot}/hubzone`,
    GET_HX_TRACKING: id => `/api/integration/hx/${id}/tracking`,
    BOOK_HX_LOADFROMQUOTE: (consignmentId: string, loadId: number, quoteId: number, companyToUse: number, agreedRate: number) => `/api/integration/hx/${consignmentId}/bookloadfromquote?loadid=${loadId}&quoteId=${quoteId}&companyToUse=${companyToUse}&agreedRate=${agreedRate}`,
    UPDATE_HX_LOAD: (consignmentId: number, loadId: number) => `/api/integration/hx/${consignmentId}/updateload/${loadId}`,
    BOOK_HX_LOADFROMQUOTEOVERIDE: (consignmentId: string, loadId: number, quoteId: number, companyToUse: number, agreedRate: number) => `/api/integration/hx/${consignmentId}/bookloadfromquoteoveride?loadid=${loadId}&quoteId=${quoteId}&companyToUse=${companyToUse}&agreedRate=${agreedRate}`,
  },
  STANDINGORDERS: {
    CREATE: '/api/standingorder/create',
    UPDATE: '/api/standingorder/update',
    RELEASE_ORDER: '/api/standingorder/releaseorder',

    DELETE: (orderTemplateId: string) => {
      return `/api/standingorder/${orderTemplateId}`;
    },
    GET_STANDINGORDER: (orderTemplateId: string) => {
      return `/api/standingorder/orderTemplate/${orderTemplateId}`;
    },
    GET_STANDINGORDER_BY_CUSTOMER: (customerId: string, startDate: Date, endDate: Date) => {
      return `/api/standingorder/customer?customerId=${customerId}&startDate=${startDate}&endDate=${endDate}`;
    },
    GET_STANDINGORDER_BY_CUSTOMER_PAGING:  '/api/standingorder/orderbypagination',
    GET_ORDERCONSIGNMENTS_BY_ORDERTEMPLATE: (orderTemplateId: string, startDate: Date, endDate: Date) => {
      return `/api/standingorder/orderconsignment?orderTemplateId=${orderTemplateId}&startDate=${startDate}&endDate=${endDate}`;
    },
    GET_ORDERCONSIGNMENTS_BY_ORDERTEMPLATE_PAGING: '/api/standingorder/orderconsignmentbypagination',
    GET_CONSIGNMENT_BY_IDNUMBER: (consignmentIdNumber: number) => {
      return `/api/standingorder/consignmentsbyidnumber?consignmentIDNumber=${consignmentIdNumber}`;
    },

    CREATE_HOLIDAY: '/api/standingorder/holiday/create',
    UPDATE_HOLIDAY: '/api/standingorder/holiday/update',
    DELETE_MONTH_HOLIDAY: (country: string, year: number, month: number) => {
      return `/api/standingorder/holiday/deletemonth?country=${country}&year=${year}&month=${month}`
    },

    DELETE_HOLIDAY: (id: string) => {
      return `/api/standingorder/holiday/delete/${id}`;
    },
    GET_HOLIDAY: (id: string) => {
      return `/api/standingorder/holiday/${id}`;
    },
    GET_HOLIDAY_BY_COUNTRY: (countryName: string) => {
      return `/api/standingorder/holiday/country/${countryName}`;
    },
    GET_HOLIDAYS_BY_PAGING: '/api/standingorder/holiday/bypagination',

  }

};
